var app = angular.module("leonardo");

var DocumentStates = function($stateProvider) {
  $stateProvider.state('documents', {
    url: '/documents',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: function (PermissionService) {
      if (PermissionService.permissionAvailableAccount('permission_view_documents', true)) {
        return 'documents.list';
      }
      else {
        return 'documents.expired';
      }
    },
    ncyBreadcrumb: {
      label: 'Document Manager'
    }
  });

  $stateProvider.state('documents.list', {
    url: "/list/:pk?from-mail",
    title: 'Documents',
    params: {
      pk: '',
      'from-mail': {
        value: null,
        squash: true
      },
      squash: false
    },
    only_filter_account:true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/document/list.html',
        controller: 'DocumentList'
      },
      'title@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/document-list.html',
        controller: 'DocumentListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'DocumentListFilter'
      },
      'breadcrumb@authenticated.layout-main': {
        templateUrl: 'views/templates/document/breadcrumb.html',
        controller: 'DocumentBreadCrumb'
      }
    },
    ncyBreadcrumb: {
      label: 'Library'
    }
  });

  $stateProvider.state('documents.expired', {
    url: "/expired",
    title: 'Documents On Notice or Expired',
    hide_home: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'DocumentFiltersExpired'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/document/expired.html',
        controller: 'DocumentListExpired'
      }
    },
    ncyBreadcrumb: {
      label: 'Dashboard'
    }
  });

  $stateProvider.state('documents.report', {
    url: "/report",
    title: 'Report Warehouse',
    hide_home: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'DocumentFiltersExpired'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/document/report.html',
        controller: 'DocumentListReport'
      }
    },
    ncyBreadcrumb: {
      label: 'Report Warehouse'
    }
  });

  $stateProvider.state('documents.property', {
    url: "/property/:pk",
    title: 'Property Folders',
    params: {
      pk: '',
      squash: false
    },
    hide_breadcrumb: true,
    mode: 'property',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/document/list.html',
        controller: 'DocumentList'
      },
      'title@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/document-list.html',
        controller: 'DocumentListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'DocumentSetupFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Setup - Property Folders'
    }
  });

  $stateProvider.state('documents.portfolio', {
    url: "/portfolio/:pk",
    title: 'Portfolio Folders',
    params: {
      pk: '',
      squash: false
    },
    hide_breadcrumb: true,
    mode: 'portfolio',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/document/list.html',
        controller: 'DocumentList'
      },
      'title@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/document-list.html',
        controller: 'DocumentListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'DocumentSetupFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Setup - Portfolio Folders'
    }
  });

  $stateProvider.state('documents.account', {
    url: "/account/:pk",
    title: 'Account Folders',
    params: {
      pk: '',
      squash: false
    },
    hide_breadcrumb: true,
    mode: 'account',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/document/list.html',
        controller: 'DocumentList'
      },
      'title@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/document-list.html',
        controller: 'DocumentListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'DocumentSetupFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Library'
    }
  });
};

app.config(['$stateProvider', DocumentStates]);
